import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from "general/components/OtherKeenComponents/KTBSButton";
import KTBSCard from "general/components/OtherKeenComponents/KTBSCard";
import AppColors from "general/constants/AppColors";
import { useTranslation } from "react-i18next";
import BankCard from "../BankCard";
import EmptyView from "general/components/Others/EmptyView";
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import DialogAddBankAccountView from "../DialogAddBankAccountView";
import { AppCustomDialogHelper } from "general/components/AppDialogCustom";
import { AppDialogHelper } from "general/components/AppDialog";
import AppResource from "general/constants/AppResource";
import ToastHelper from "general/helpers/ToastHelper";
import agencyBankHelper from "general/helpers/agencyBankHelper";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import AppConstants from "general/constants/AppConstants";
import MaintainerHelper from "features/Maintainer/maintainerHelper";
import UIHelper from "general/helpers/UIHelper";
import Utils from "general/utils/Utils";
import FleetHelper from "features/Fleet/fleetHelper";

BankAccountsView.propTypes = {
    agencyId: PropTypes.string,
    agencyDetail: PropTypes.object,
    banksList: PropTypes.array,
    getAgencyBankList: PropTypes.func,
};

function BankAccountsView(props) {
    const { agencyId, agencyDetail, banksList, getAgencyBankList } = props;
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);
    const isMaintainer = user?.role === 'MAINTAINER';
    const isFleet = user?.role === 'FLEET';

    const isAgencyInfo = useMemo(() => {
        return Number(user?.agency?.agencyId) === Number(agencyId)
    }, [user, agencyId])
    const adminRole = user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

    const disabledEditBank = useMemo(() => {
        return agencyDetail?.numberOfSignedContracts > 0 && !adminRole
    }, [agencyDetail, adminRole])

    const handleRefresh = () => {
        getAgencyBankList();
    };

    const handleSetDefaultBank = (item) => {
        AppDialogHelper.show(
            'Đặt làm mặc định',
            `Bạn có chắc muốn đặt tài khoản ngân hàng <span class="font-weight-boldest text-gray-800">${item?.bankAccount}</span> là mặc định không?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Áp dụng',
                    type: 'success',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        let isSuccess;
                        if (isMaintainer) {
                            isSuccess = await MaintainerHelper.API.requestUpdateMaintainerBank(item?.bankAccountId, {
                                defaultAccount: 1
                            });
                        } else if (isFleet) {
                            isSuccess = await FleetHelper.API.requestUpdateFleetBank(item?.bankAccountId, {
                                defaultAccount: 1
                            });
                        } else {
                            isSuccess = await agencyBankHelper.callApiUpdateAgencyBank(item?.bankAccountId, {
                                defaultAccount: 1
                            });
                        }
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Đặt tài khoản mặc định thành công`);
                            handleRefresh();
                        } else {
                            ToastHelper.showError(`Đặt tài khoản mặc định thất bại`);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogSetDefault
        );
    }

    const handleAddNew = (item) => {
        AppCustomDialogHelper.show(
            !!item ? 'Chỉnh sửa tài khoản ngân hàng' : 'Thêm tài khoản ngân hàng',
            <DialogAddBankAccountView
                agencyId={agencyId}
                item={item}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh();
                }}
            />,
            'md',
            false,
            true
        );
    };

    const handleLockBank = (item) => {
        AppDialogHelper.show(
            'Tạm khóa tài khoản ngân hàng',
            `Bạn có chắc chắn muốn tạm khóa tài khoản ngân hàng <span class="font-weight-boldest text-gray-800">${item?.bankAccount}</span> không?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Tạm khóa',
                    type: 'negative',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        let isSuccess;
                        if (isMaintainer) {
                            isSuccess = await MaintainerHelper.API.requestUpdateMaintainerBank(item?.bankAccountId, {
                                status: 'LOCKED',
                            });
                        } else if (isFleet) {
                            isSuccess = await FleetHelper.API.requestUpdateFleetBank(item?.bankAccountId, {
                                status: 'LOCKED',
                            });
                        } else {
                            isSuccess = await agencyBankHelper.callApiUpdateAgencyBank(item?.bankAccountId, {
                                status: 'LOCKED',
                            });
                        }

                        if (isSuccess) {
                            ToastHelper.showSuccess(`Tạm khóa tài khoản ngân hàng thành công`);
                            handleRefresh();
                        } else {
                            ToastHelper.showError(`Tạm khóa tài khoản ngân hàng thất bại`);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogLock
        );
    }

    const handleUnlockBank = (item) => {
        AppDialogHelper.show(
            'Mở khóa tài khoản ngân hàng',
            `Bạn có chắc chắn muốn mở khóa tài khoản ngân hàng <span class="font-weight-boldest text-gray-800">${item?.bankAccount}</span> không?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Mở khóa',
                    type: 'success',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        let isSuccess;
                        if (isMaintainer) {
                            isSuccess = await MaintainerHelper.API.requestUpdateMaintainerBank(item?.bankAccountId, {
                                status: 'VALIDATED',
                            });
                        } else if (isFleet) {
                            isSuccess = await FleetHelper.API.requestUpdateFleetBank(item?.bankAccountId, {
                                status: 'VALIDATED',
                            });
                        } else {
                            isSuccess = await agencyBankHelper.callApiUpdateAgencyBank(item?.bankAccountId, {
                                status: 'VALIDATED',
                            });
                        }
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Mở khóa tài khoản ngân hàng thành công`);
                            handleRefresh();
                        } else {
                            ToastHelper.showError(`Mở khóa tài khoản ngân hàng thất bại`);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogSetDefault
        );
    }

    const handleDeleteBank = (item) => {
        AppDialogHelper.show(
            'Gỡ bỏ tài khoản ngân hàng',
            `Bạn có chắc chắn muốn gỡ bỏ tài khoản ngân hàng <span class="font-weight-boldest text-gray-800">${item?.bankAccount}</span> không?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Gỡ bỏ',
                    type: 'negative',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        let isSuccess;
                        if (isMaintainer) {
                            isSuccess = await MaintainerHelper.API.requestDeleteMaintainerBank(item?.bankAccountId);
                        } else if (isFleet) {
                            isSuccess = await FleetHelper.API.requestDeleteFleetBank(item?.bankAccountId);
                        } else {
                            isSuccess = await agencyBankHelper.callApiDeleteAgencyBank(item?.bankAccountId);
                        }
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Gỡ bỏ tài khoản ngân hàng thành công`);
                            handleRefresh();
                        } else {
                            ToastHelper.showError(`Gỡ bỏ tài khoản ngân hàng thất bại`);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogDeleteVehicle
        );
    }

    return (
        <div className="">
            {UIHelper.buildCard(
                <div className="pb-4">
                    {/* header */}
                    <div className="px-4 pt-4 pb-3 d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column">
                            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                Danh sách tài khoản ngân hàng
                            </span>
                            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                Tổng:{' '}
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                    {Utils.formatNumber(banksList?.length)} tài khoản
                                </span>
                            </span>
                        </div>

                        <div className="d-flex gap-3">
                            {isAgencyInfo && (
                                <KTBSButton
                                    color={KTBSButtonColor.success}
                                    title={t('Thêm tài khoản ngân hàng')}
                                    size={KTBSButtonSize.default}
                                    borderRadius={5}
                                    buttonTitleFontWeight="600"
                                    iconElement={<i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />}
                                    onPress={handleAddNew}
                                    height={43}
                                    buttonTitleFontSize={14}
                                />
                            )}
                        </div>
                    </div>

                    <div className="px-5">
                        {banksList?.length ? (
                            <div className="row">
                                {banksList
                                    .sort((a, b) => (b.defaultAccount ? 1 : 0) - (a.defaultAccount ? 1 : 0))
                                    .map((item, index) => (
                                        <div key={`BANK_ACCOUNT_${item?.bankAccountId ?? index}`} className="col-xl-4 col-lg-6 col-md-6 col-12 py-2 min-w-325px d-flex">
                                            <BankCard
                                                item={item}
                                                onSetDefault={() => handleSetDefaultBank(item)}
                                                onEdit={() => handleAddNew(item)}
                                                onLock={() => handleLockBank(item)}
                                                onUnlock={() => handleUnlockBank(item)}
                                                onDelete={() => handleDeleteBank(item)}
                                                isAgencyInfo={isAgencyInfo}
                                                adminRole={adminRole}
                                                disabledEditBank={disabledEditBank}
                                            />
                                        </div>
                                    ))}
                            </div>
                        ) : (
                            <EmptyView
                                icon={imgEmptyNoData}
                                title="Không có dữ liệu để hiển thị"
                                text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                            />
                        )}
                    </div>
                </div>,
                false,
                false,
                true,
                false,
                AppColors.gray[300],
                true
            )}
        </div>
    );
}

export default BankAccountsView;